import { forwardRef } from 'react';
import type { MediaPlayerInstance } from '@vidstack/react';

import type { Video } from '@virginexperiencedays/products';

import { VideoPlayer, type VideoPlayerProps } from '../VideoPlayer';

const DEFAULT_RESOLUTION = 480;

type Props = Omit<VideoPlayerProps, 'poster' | 'src'> & {
  url?: string;
  video?: Video;
};

export const VideoPlayerBunny = forwardRef<MediaPlayerInstance, Props>(
  ({ url, video, ...rest }, ref) => {
    if (!video?.videoId || !url) return null;

    return (
      <VideoPlayer
        ref={ref}
        poster={`${url}/${video.videoId}/thumbnail_1.jpg`}
        src={[
          { src: `${url}/${video.videoId}/playlist.m3u8`, type: 'application/x-mpegurl' },
          { src: `${url}/${video.videoId}/play_${DEFAULT_RESOLUTION}p.mp4`, type: 'video/mp4' },
        ]}
        {...rest}
      />
    );
  }
);

VideoPlayerBunny.displayName = 'VideoPlayerBunny';
